<template>
  <div class="edit-page">
    <div v-if="courseId" class="tab-box">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        :disabled="isSaveing"
        class="tab-item"
        :class="item.value === tabActive ? 'tab-item-active' : ''"
        @click="handleChangeTab(item.value)"
      >
        {{ item.name }}
      </div>
      <div v-if="tabActive === 'good'" class="btn-box">
        <Button type="primary" @click="handleAddGoods">发布课程商品</Button>
        <Button @click="handleToBatch">批量设置</Button>
      </div>
    </div>
    <AnchorContainer
      v-show="tabActive === 'course'"
      :anchor-block-top="courseId ? 173 : 125"
    >
      <!-- 课程信息 -->
      <AnchorItem
        id="baseInfo"
        :name="baseInfoNameObj.name"
        :icon="baseInfoNameObj.icon"
        :icon-color="baseInfoNameObj.iconColor"
      >
        <ResourcesBaseInfo
          ref="resourcesBaseInfo"
          v-model="baseInfo"
          :course-id="courseId"
          :is-copy="isCopy"
          :the-user-identity="theUserIdentity"
          :validate-pass.sync="formValidatePass.baseInfo"
        ></ResourcesBaseInfo>
      </AnchorItem>
      <AnchorItem
        id="courseDetailInfo"
        :name="courseDetailInfoNameObj.name"
        :icon="courseDetailInfoNameObj.icon"
        :icon-color="courseDetailInfoNameObj.iconColor"
      >
        <CourseDetailInfo
          ref="courseDetailInfo"
          v-model="courseDetailInfo"
          :course-id="courseId"
          :the-user-identity="theUserIdentity"
          :validate-pass.sync="formValidatePass.courseDetailInfo"
          :download-url="downloadUrl"
        ></CourseDetailInfo>
      </AnchorItem>
      <AnchorItem
        id="materialInfo"
        :name="materialInfoNameObj.name"
        :icon="materialInfoNameObj.icon"
        :icon-color="materialInfoNameObj.iconColor"
      >
        <MaterialInfo
          ref="materialInfo"
          v-model="materialInfo"
          :course-id="courseId"
          :the-user-identity="theUserIdentity"
          :validate-pass.sync="formValidatePass.materialInfo"
        ></MaterialInfo>
      </AnchorItem>
      <AnchorItem id="otherInfo" name="其他信息">
        <OtherInfo
          v-model="otherInfo"
          :course-id="courseId"
          :the-user-identity="theUserIdentity"
          :upload-token="uploadToken"
          :upload-url="UploadUrl"
        ></OtherInfo>
      </AnchorItem>
      <div class="formbtnbox-430-bottom">
        <Button
          type="primary"
          :loading="isSaveing"
          @click="handleSave"
        >保存</Button>
        <Button @click="handleCancle">取消</Button>
      </div>
    </AnchorContainer>
    <div v-if="courseId && tabActive === 'good'" class="goods-list-box">
      <GoodsList
        ref="goodsList"
        :is-shelves-school-list="isShelvesSchoolList"
      ></GoodsList>
    </div>
  </div>
</template>
<script>
// 锚点组件start
import AnchorContainer from '@c/Anchor/AnchorContainer.vue';
import AnchorItem from '@c/Anchor/AnchorItem.vue';
// 锚点组件end
// 基础信息start
import ResourcesBaseInfo from './assets/components/ResourcesBaseInfo.vue';
// 基础信息end
// 课程详情start
import CourseDetailInfo from './assets/components/CourseDetailInfo.vue';
// 课程详情end
// 课程材料start
import MaterialInfo from './assets/components/MaterialInfo.vue';
// 课程材料end
// 其他信息start
import OtherInfo from './assets/components/OtherInfo.vue';
// 其他信息end
import GoodsList from './assets/components/GoodsList.vue';
import {
  baseInfo,
  courseDetailInfo,
  materialInfo,
  otherInfo
} from './assets/data/editCurriculumForm';
import { mapState, mapGetters, mapMutations } from 'vuex';
import resourcesManagementApi from '@/request/courseCenter/resources';
import { getText, getGradeMinAndMax } from '@/utils/utils';
import axios from 'axios';
export default {
  name: 'CourseCenterResourcesEditCourse',
  components: {
    AnchorContainer,
    AnchorItem,
    ResourcesBaseInfo,
    CourseDetailInfo,
    MaterialInfo,
    OtherInfo,
    GoodsList
  },
  provide() {
    // findRuleRequireNew (子组件有用到这个方法，不要删！)
    return { EditCurriculumInstance: this };
  },
  data() {
    return {
      baseInfo: { ...baseInfo },
      courseDetailInfo: { ...courseDetailInfo },
      materialInfo: { ...materialInfo },
      otherInfo: { ...otherInfo },
      courseId: '', // 课程资源id(编辑的时候有)
      baseInfoNameObj: {},
      courseDetailInfoNameObj: {},
      materialInfoNameObj: {},
      uploadToken: '',
      UploadUrl: '',
      downloadUrl: '',
      formValidatePass: {
        baseInfo: false,
        courseDetailInfo: false,
        materialInfo: false
      },
      getAllData: false,
      tabActive: 'course',
      tabList: [
        {
          name: '课程资源',
          value: 'course'
        },
        {
          name: '课程商品',
          value: 'good'
        }
      ],
      isShelvesSchoolList: [], // 已上架的学校
      isSaveing: false, // 是否正在保存
      isCopy: false // 是否是复制
    };
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['theUserIdentity'])
  },
  watch: {

    getAllData(newVal) {
      if (newVal) {
        this.submitFormTrue();
      }
    },
    formValidatePass: {
      handler(newVal, oldVal) {
        console.log('新的----', newVal);
        this.getAllData = Object.keys(this.formValidatePass).every(item => {
          return this.formValidatePass[item];
        });
        if (!this.getAllData) {
          this.isSaveing = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.$route.query.courseId
      ? (this.courseId = this.$route.query.courseId)
      : '';
    this.$route.query.tab ? (this.tabActive = this.$route.query.tab) : '';
    this.$route.query.copy
      ? this.$route.query.copy == '1'
        ? (this.isCopy = true)
        : (this.isCopy = false)
      : '';
    console.log('copy', this.$route.query.copy, this.isCopy);
    this.getUploadtoken();
  },
  mounted() {
    if (this.theUserIdentity !== 'admin' && this.courseId === '') {
      this.baseInfo.orgId = this.userInfo.orgId;
      this.baseInfo.orgName = this.userInfo.orgName;
      // this.$refs.baseInfo.getRelEduFun();
    }
    if (this.courseId) {
      this.getCourseDetail();
    }
  },
  methods: {
    ...mapMutations([
      'CLOSE_BROWSINGHISTORYLIST', 'DELETE_CACHEROUTE'
    ]),
    // 切换
    handleChangeTab(value) {
      this.tabActive = value;
    },
    fillKeyValue(target, value) {
      Object.keys(target).forEach(item => {
        if (value[item]) {
          target[item] = value[item];
        }
      });
      return target;
    },
    async getCourseDetail() {
      const params = {
        courseId: this.courseId
      };
      try {
        const {
          message,
          status
        } = await resourcesManagementApi.getCourseDetail(params);
        if (status === 200) {
          this.isShelvesSchoolList = message.schoolList
            ? message.schoolList.map(item => {
              item.id = item.orgId;
              return item;
            })
            : [];
          this.baseInfo = this.fillKeyValue(this.baseInfo, message);
          this.baseInfo.courseType = [
            message.trainingType + '',
            message.courseTypeKind + '',
            message.courseTypeId
          ];
          this.baseInfo.studentSuggestMin =
            +message.studentSuggestMin === 0 ? '' : message.studentSuggestMin;
          this.baseInfo.studentSuggestMax =
            +message.studentSuggestMax === 0 ? '' : message.studentSuggestMax;
          // +this.baseInfo.termId === 0 ? (this.baseInfo.termId = '') : '';
          this.baseInfo = { ...this.baseInfo, ...getGradeMinAndMax(message.gradeMin, message.gradeMax) };

          this.courseDetailInfo = this.fillKeyValue(
            this.courseDetailInfo,
            message
          );
          this.$refs.courseDetailInfo.fillEditor(
            this.courseDetailInfo.courseDescribe
          );
          this.courseDetailInfo.courseCoverShow = message.courseCover
            ? {
              fileId: message.courseCover,
              imgShow: '',
              file: null
            }
            : null;

          this.courseDetailInfo.courseAchievementShow = this.courseDetailInfo
            .courseAchievement
            ? this.courseDetailInfo.courseAchievement.split(',').map(item => {
              return {
                fileId: item,
                file: null,
                imgShow: ''
              };
            })
            : [];

          this.courseDetailInfo.coursePriceShow = Number(message.coursePrice)
            ? Number(message.coursePrice) / 100 + ''
            : null;
          this.courseDetailInfo.outCoursePriceShow = Number(
            message.ocoursePrice
          )
            ? Number(message.ocoursePrice) / 100 + ''
            : null;

          this.materialInfo = this.fillKeyValue(this.materialInfo, message);
          this.materialInfo.attachmentPriceShow = Number(
            message.attachmentPrice
          )
            ? Number(message.attachmentPrice) / 100 + ''
            : null;
          this.otherInfo.costFileLst = message.costFileLst;

          console.log(this.baseInfo, '基础信息0000===');
          this.$nextTick(() => {
            this.$refs.resourcesBaseInfo.updateCascaderBox();
            this.$refs.resourcesBaseInfo.setTerm();
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 上传token
    async getUploadtoken() {
      return new Promise((resolve, reject) => {
        this.$http.getUploadtoken().then(res => {
          this.uploadToken = res.message.token;
          this.UploadUrl = res.message.upUrl;
          this.downloadUrl = res.message.downUrl;
          resolve(res);
        });
      });
    },
    findRuleRequireNew(context, tag, name, checkIsFalse = false) {
      // 拿到必填的项
      const requireKeys = Object.keys(context[`${tag}Rule`]).filter(item => {
        return context[`${tag}Rule`][item][0].required;
      });
      let hasFilled = 0;
      requireKeys.forEach(item => {
        if (
          context[`${tag}Rule`][item][0].type === undefined &&
          context[tag][item]
        ) {
          hasFilled += 1;
        } else if (
          context[`${tag}Rule`][item][0].type &&
          context[`${tag}Rule`][item][0].type === typeof context[tag][item]
        ) {
          hasFilled += 1;
        } else if (
          context[`${tag}Rule`][item][0].type &&
          context[`${tag}Rule`][item][0].type === 'array' &&
          JSON.stringify(context[tag][item]) !== '[]'
        ) {
          hasFilled += 1;
        }
      });
      const obj = {
        hasFilled,
        requireKeyslength: requireKeys.length
      };
      const hasFinished =
        obj.hasFilled !== 0 && obj.hasFilled === obj.requireKeyslength;
      this[`${tag}NameObj`] = {
        name:
          obj.requireKeyslength === 0
            ? `${name}`
            : `${name} （${obj.hasFilled} / ${obj.requireKeyslength}）`,
        icon: checkIsFalse
          ? 'ios-alert'
          : hasFinished
            ? 'md-checkmark-circle'
            : '',
        iconColor: checkIsFalse ? '#ed4014' : hasFinished ? '#19be6b' : ''
      };
    },
    async handleSave() {
      this.formValidatePass = {
        baseInfo: false,
        courseDetailInfo: false,
        materialInfo: false
      };
      this.getAllData = false;
      this.isSaveing = true;
      this.$refs.resourcesBaseInfo.checkForm();
      await this.$refs.courseDetailInfo.checkForm();
      this.$refs.materialInfo.checkForm();
    },
    handleCancle() {
      this.handleGoBack();
    },
    async submitFormTrue() {
      try {
        const formValidate = {};
        Object.assign(
          formValidate,
          this.baseInfo,
          this.courseDetailInfo,
          this.materialInfo,
          this.otherInfo
        );
        const param = JSON.parse(JSON.stringify(formValidate));
        if (this.baseInfo.gradeMin > this.baseInfo.gradeMax) {
          param.gradeMax = this.baseInfo.gradeMin;
          param.gradeMin = this.baseInfo.gradeMax;
        }
        param.studentSuggestMin = param.studentSuggestMin
          ? param.studentSuggestMin
          : 0;
        param.studentSuggestMax = param.studentSuggestMax
          ? param.studentSuggestMax
          : 0;
        param.courseCover = this.courseDetailInfo.courseCoverShow
          ? await this.uploadImg(this.courseDetailInfo.courseCoverShow)
          : '';
        const courseAchievementArr = [];
        for (const key in this.courseDetailInfo.courseAchievementShow) {
          courseAchievementArr.push(
            await this.uploadImg(
              this.courseDetailInfo.courseAchievementShow[key]
            )
          );
        }
        param.courseAchievement = courseAchievementArr.join();
        delete param.courseCoverShow;
        delete param.courseAchievementShow;
        // return console.log(param, '入参---432');

        if (this.courseId && !this.isCopy) {
          param.courseId = this.courseId;
          this.editCourseForm(param);
        } else {
          this.addCourseForm(param);
        }
      } catch (err) {
        this.isSaveing = false;
      }
    },
    async uploadImg(fileObj) {
      if (fileObj.fileId) {
        return fileObj.fileId;
      }
      if (fileObj.file === null) {
        return '';
      }
      return new Promise(async(resolve, reject) => {
        const file = fileObj.file;
        console.log(file, '文件----');
        const formData = new FormData();
        const r = await this.getUploadtoken();
        const obj = { token: '', upUrl: '', downUrl: '' };
        if (r.status === 200) {
          Object.assign(obj, r.message);
        }

        formData.append('token', obj.token);
        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        axios.post(obj.upUrl, formData, configs).then(res => {
          if (res.data.status === 200) {
            const id = res.data.message.fileId;
            resolve(id);
          } else {
            this.$Message.warning(res.data.error);
          }
        });
      });
    },
    // 添加课程资源
    async addCourseForm(params) {
      this.$Spin.show();
      try {
        const resp = await resourcesManagementApi.addCourse(params);
        if (resp.status === 200) {
          this.DELETE_CACHEROUTE('courseCenterResourcesCourseTable');
          this.$Message.success('添加成功');
          this.handleGoBack();
        } else {
          this.isSaveing = false;
        }
      } catch (err) {
        this.isSaveing = false;
      } finally {
        this.$Spin.hide();
      }
    },
    // 编辑课程资源
    async editCourseForm(params) {
      this.$Spin.show();
      try {
        const resp = await resourcesManagementApi.updateCourse(params);
        if (resp.status === 200) {
          this.$Message.success('编辑课程成功');
          this.handleGoBack();
        } else {
          this.isSaveing = false;
        }
      } catch (err) {
        console.log('err-->', err);
        this.isSaveing = false;
      } finally {
        this.$Spin.hide();
      }
    },
    handleGoBack() {
      this.CLOSE_BROWSINGHISTORYLIST(this.$route.name);
      this.$router.push({
        name: `courseCenter_resources_courseTable`
      });
    },
    handleAddGoods() {
      this.$nextTick(() => {
        this.$refs.goodsList.handleRelease();
      });
    },
    // 批量设置
    handleToBatch() {
      this.$nextTick(() => {
        this.$refs.goodsList.handleSet();
      });
    }

  }
};
</script>
<style lang="scss" scoped>
.edit-page {
  padding-bottom: 80px;
}
.tab-box {
  background: #fff;
  display: flex;
  margin: 0 16px;
  position: sticky;
  top: 0;
  .tab-item {
    cursor: pointer;
    padding: 16px 32px 12px 32px;
    font-weight: bold;
    font-size: 16px;
    box-sizing: border-box;
    border-bottom: 4px solid #fff;
  }
  .tab-item-active {
    color: #488ffa;
    border-bottom: 4px solid #488ffa;
  }
}
.formbtnbox-430-bottom {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1000;
  left: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 0 -4px 2px rgba(0, 0, 0, 0.03);
  padding: 16px 0;

  button + button {
    margin-left: 16px;
  }
}
.goods-list-box {
  padding: 16px;
}
.btn-box {
  position: absolute;
  right: 16px;
  top: 50%;
  margin-top: -16px;
  button + button {
    margin-left: 16px;
  }
}
</style>
